import Ajax from 'global/od/Ajax';

const orderHistoryReorderModel = (data, url) =>
	Ajax({
		url,
		method: 'POST',
		dataType: 'html',
		data,
		contentType: 'application/json',
	});

export default orderHistoryReorderModel;
